export default __webpack_public_path__ + "static/media/img-logo.e2ff899d.png";